export default {
  open: [
    {
      _name: "CSidebarNavTitle",
      _children: ["v2-Quét online"],
      permission: 'scan_item'
    },
    {
      _name: "CSidebarNavItem",
      name: "Dữ liệu",
      to: "/v2/online_scan",
      icon: "cil-layers",
      permission: 'scan_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Nhập liệu",
      to: "/v2/online_scan/new",
      icon: "cil-layers",
      permission: 'scan_input'
    },
    {
      _name: "CSidebarNavItem",
      name: "Thống kê",
      to: "/v2/online_scan/analytics",
      icon: "cil-layers",
      permission: 'scan_analytics'
    },
  ],
  sale_limited: [
    {
      _name: "CSidebarNavTitle",
      _children: ["v2-Quét online"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Dữ liệu",
      to: "/v2/online_scan",
      icon: "cil-layers",
      permission: 'scan_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Nhập liệu",
      to: "/v2/online_scan/new",
      icon: "cil-layers",
      permission: 'scan_input'
    }
  ]
};

